<dialog #dialog class="z-50 rounded-2xl shadow" data-cy="modal">
  @switch (type) {
    @case ('info') {
      <div class="bg-opacity-40 fixed inset-0 bg-white backdrop-blur-sm"></div>
      <div class="relative flex flex-col bg-white p-6">
        <header class="flex items-center justify-center border-b border-black p-4">
          <h3 class="text-main-blue text-[18px] font-bold">Information</h3>
        </header>
        <div class="mb-8 flex flex-col items-center justify-center space-y-3.5">
          <p class="font-boldleading-relaxed flex flex-col items-center justify-center pt-6 font-bold text-[#404041]">
            <a href="https://www.mlb.com/app/ballpark/official-information/terms-of-use" target="_blank"
              >Terms of Use</a
            >
          </p>
          <p class="flex flex-col items-center justify-center leading-relaxed font-bold text-[#404041]">
            <a href="https://www.mlb.com/app/ballpark/official-information/privacy-policy" target="_blank"
              >Privacy Policy</a
            >
          </p>
          <p class="flex flex-col items-center justify-center leading-relaxed font-bold text-[#404041]">
            <a target="_blank" [href]="'mailto:' + supportEmail">Technical Support</a>
          </p>
          <p class="flex flex-col items-center justify-center text-xs leading-relaxed font-semibold text-[#19294e]">
            <a>{{ email }}</a>
          </p>
        </div>
        <div class="mb-5 flex self-center text-center text-xs font-semibold text-[#a9a9a9]">
          © {{ year() }} MLB Advanced Media, L.P. All rights reserved.
        </div>
        <div class="text-main-grey self-center text-xs font-semibold">
          <span> v{{ pack.version }} </span>
        </div>
        <div class="flex items-center justify-center space-x-2 rounded-b border-gray-200 p-6">
          <app-square-button backgroundColor="bg-secondary-blue" [action]="closeAction" [text]="buttonText!" />
        </div>
      </div>
    }
    @default {
      <div class="bg-opacity-40 fixed inset-0 bg-white backdrop-blur-sm"></div>
      <div class="relative bg-white px-8">
        <header class="flex items-center justify-center border-b p-4">
          <h3 class="text-main-blue text-xl font-semibold">Error</h3>
        </header>
        <div class="space-y-6 p-3 text-center">
          <p class="overflow-x-auto text-base leading-relaxed text-gray-500">{{ modalText }}</p>
        </div>
        <div class="flex justify-center space-x-2 rounded-b border-gray-200 p-6">
          <app-square-button
            backgroundColor="bg-secondary-blue"
            class="w-full"
            [action]="closeAction"
            [text]="buttonText!" />
        </div>
      </div>
    }
  }
</dialog>
